'use client';

import { useState, useEffect } from 'react';
import ContactHero from './ContactHero';
import ContactMethods from './ContactMethods';
import ConsultationForm from './ConsultationForm';
import LocationInfo from './LocationInfo';
import FAQSection from './FAQSection';
import EmergencyModal from './EmergencyModal';

export default function ContactInteractive() {
  const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="h-96 bg-gradient-to-br from-primary via-secondary to-brand-primary animate-pulse" />
        <div className="container mx-auto px-4 py-16">
          <div className="space-y-8">
            <div className="h-64 bg-muted rounded-lg animate-pulse" />
            <div className="h-96 bg-muted rounded-lg animate-pulse" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <ContactHero onEmergencyClick={() => setIsEmergencyModalOpen(true)} />
      <ContactMethods />
      <ConsultationForm />
      <LocationInfo />
      <FAQSection />
      <EmergencyModal
        isOpen={isEmergencyModalOpen}
        onClose={() => setIsEmergencyModalOpen(false)}
      />
    </>
  );
}